import React from 'react'
import copyToClipboard from 'copy-to-clipboard'
import {message} from 'antd'
import useTranslate from 'modules/local/useTranslate'
import {getId} from 'apis/model/base'
import {ROOT_URL} from 'envs/_current/config'
import {Link} from 'react-router-dom'
import {IoArrowForwardOutline, IoCopyOutline, IoLinkOutline} from 'react-icons/io5'

// Block "chia sẻ link truy cập access-portal" - tách ra từ FamilyBookOverviewPage.js (nơi khai
// sinh) để DÙNG CHUNG cho mọi feature_key có access-portal (hiện: organization_manage_sacrament,
// organization_manage_course - xem config/feature_access_grants.php BE). Không lặp lại UI quản lý
// danh sách người được cấp (mời/thu hồi) - đó là WorkspaceFeatureAccessGrants.js, mục Thiết lập hệ
// thống > Phân quyền & Vai trò > Cấp quyền tạm thời (đúng route manageLink bên dưới trỏ tới).
// titleKey/hintKey: text theo TỪNG feature (khác nhau "Sổ Gia Đình" / "Khóa học"...) - caller tự
// truyền key i18n phù hợp, component không tự đoán.
// colorPrefix: tên thang màu domain-theme (khớp utility class bg-{prefix}-N/text-{prefix}-N đã có
// sẵn ở custom.scss, vd "education", "family") - mặc định "amber" (thang Tailwind chuẩn) để giữ
// nguyên giao diện các nơi gọi cũ (FamilyBookOverviewPage.js) không bị đổi màu ngoài ý muốn.
// buttonClassName: override riêng cho nút copy khi domain đó không dùng đúng nấc N của colorPrefix
// làm accent (vd Education dùng accent vàng riêng --color-education-gold, không phải education-600).
export const AccessPortalIntroBlock = ({organization, featureKey, titleKey, hintKey, colorPrefix = 'amber', buttonClassName}) => {
    const t = useTranslate()
    const orgId = getId(organization)
    const link = `${ROOT_URL}/access-portal?org_id=${orgId}&feature_key=${featureKey}`
    const manageLink = `/workspace/setting?rel=feature-access-grants&org_id=${orgId}`

    return (
        <div className={`p-3 md:p-4 flex flex-col gap-3 bg-${colorPrefix}-50 border border-${colorPrefix}-100 rounded-2xl`}>
            {/* max-w-full + truncate - "w-fit" trước đây ép Link rộng bằng ĐÚNG nội dung (3 đoạn
                text + 2 icon mũi tên) bất kể khung cha hẹp cỡ nào, tràn hẳn ra ngoài card trên
                mobile (bạn báo lỗi này). Từng cho cuộn ngang (overflow-x-auto) nhưng pill nhỏ
                không có gợi ý là cuộn được nên đổi qua truncate (…) cho rõ, giữ nguyên 1 hàng
                (không wrap - vỡ hình breadcrumb nếu xuống dòng giữa chừng). Bỏ "flex" ở container
                vì text-overflow: ellipsis không áp dụng được lên flex item riêng lẻ - để icon/text
                trôi tự nhiên (icon SVG mặc định inline) rồi truncate cả dòng như span link bên
                dưới đã làm (dòng 46). */}
            <Link
                to={manageLink}
                className={`max-w-full block truncate px-2.5 py-1 rounded-full bg-white/70 border border-${colorPrefix}-200 text-2xs font-semibold text-${colorPrefix}-700 no-underline hover:bg-white`}>
                {t('system settings')} <IoArrowForwardOutline size={10} className="inline-block mx-0.5 -mt-0.5"/> {t('permissions & roles')} <IoArrowForwardOutline size={10} className="inline-block mx-0.5 -mt-0.5"/> {t('temporary access grants')}
            </Link>
            <div className="flex flex-col gap-1">
                <span className="font-bold text-base text-color-000">{t(titleKey)}</span>
                <span className="text-sm text-color-400 leading-snug">{t(hintKey)}</span>
            </div>
            <div className={`flex flex-col sm:flex-row sm:items-center gap-2 p-2 bg-white border border-${colorPrefix}-100 rounded-xl`}>
                <div className={`flex-1 min-w-0 flex items-center gap-2 px-2 py-1.5 rounded-lg bg-${colorPrefix}-50/60`}>
                    <IoLinkOutline size={14} className={`text-${colorPrefix}-600 flex-shrink-0`}/>
                    <span className="flex-1 min-w-0 truncate text-xs text-color-400 font-mono">{link}</span>
                </div>
                <button
                    type="button"
                    onClick={() => {
                        copyToClipboard(link)
                        message.success(t('copied'))
                    }}
                    className={buttonClassName || `px-3 py-1.5 flex items-center justify-center gap-1.5 rounded-lg bg-${colorPrefix}-600 hover:bg-${colorPrefix}-700 text-white text-xs font-semibold cursor-pointer flex-shrink-0`}>
                    <IoCopyOutline size={13}/>
                    {t('copy access portal link')}
                </button>
            </div>
        </div>
    )
}
